import React from 'react';
import { Target, Heart, Users, ArrowBigDown, BookOpen, Sprout, Shield, Activity, Leaf, Scale, Lightbulb, Music } from 'lucide-react';

const Mission: React.FC = () => {
  return (
    <section id="mission" className="py-16 md:py-24 bg-muted">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center mb-16 animated-section">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Our Mission</h2>
          <p className="text-lg text-muted-foreground">
            At Arrow Drop Foundation, we're dedicated to creating positive change through 
            focused initiatives that address community needs and promote sustainable development.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          <div className="bg-card rounded-lg p-6 shadow-subtle dark:shadow-subtle-dark animated-section flex items-start">
            <div className="mr-4 p-3 rounded-full bg-primary/10 flex-shrink-0">
              <BookOpen className="w-6 h-6 text-primary" />
            </div>
            <div>
              <h3 className="text-xl font-semibold mb-3">Education & Skill Development</h3>
              <p className="text-muted-foreground">
                Provide quality education and vocational training in CNC programming, MS Office, 
                trading tools, web development, blockchain technology, and entrepreneurship.
              </p>
            </div>
          </div>

          <div className="bg-card rounded-lg p-6 shadow-subtle dark:shadow-subtle-dark animated-section flex items-start">
            <div className="mr-4 p-3 rounded-full bg-primary/10 flex-shrink-0">
              <Sprout className="w-6 h-6 text-primary" />
            </div>
            <div>
              <h3 className="text-xl font-semibold mb-3">Agriculture & Rural Development</h3>
              <p className="text-muted-foreground">
                Promote sustainable agricultural practices, animal husbandry, fisheries, 
                and rural development programs to enhance livelihoods.
              </p>
            </div>
          </div>

          <div className="bg-card rounded-lg p-6 shadow-subtle dark:shadow-subtle-dark animated-section flex items-start">
            <div className="mr-4 p-3 rounded-full bg-primary/10 flex-shrink-0">
              <Users className="w-6 h-6 text-primary" />
            </div>
            <div>
              <h3 className="text-xl font-semibold mb-3">Social Welfare & Community Development</h3>
              <p className="text-muted-foreground">
                Support programs for children, the differently-abled, the elderly, and tribal 
                communities through education, healthcare, and economic empowerment.
              </p>
            </div>
          </div>

          <div className="bg-card rounded-lg p-6 shadow-subtle dark:shadow-subtle-dark animated-section flex items-start">
            <div className="mr-4 p-3 rounded-full bg-primary/10 flex-shrink-0">
              <Activity className="w-6 h-6 text-primary" />
            </div>
            <div>
              <h3 className="text-xl font-semibold mb-3">Health & Family Welfare</h3>
              <p className="text-muted-foreground">
                Raise awareness and provide assistance in HIV/AIDS prevention, nutrition, 
                drinking water, and general healthcare access.
              </p>
            </div>
          </div>

          <div className="bg-card rounded-lg p-6 shadow-subtle dark:shadow-subtle-dark animated-section flex items-start">
            <div className="mr-4 p-3 rounded-full bg-primary/10 flex-shrink-0">
              <Leaf className="w-6 h-6 text-primary" />
            </div>
            <div>
              <h3 className="text-xl font-semibold mb-3">Environmental & Renewable Energy</h3>
              <p className="text-muted-foreground">
                Promote sustainable practices in environmental conservation, forests, 
                and new & renewable energy adoption.
              </p>
            </div>
          </div>

          <div className="bg-card rounded-lg p-6 shadow-subtle dark:shadow-subtle-dark animated-section flex items-start">
            <div className="mr-4 p-3 rounded-full bg-primary/10 flex-shrink-0">
              <Scale className="w-6 h-6 text-primary" />
            </div>
            <div>
              <h3 className="text-xl font-semibold mb-3">Legal Awareness & Advocacy</h3>
              <p className="text-muted-foreground">
                Educate communities on human rights, RTI (Right to Information), legal aid, 
                and advocacy programs for marginalized groups.
              </p>
            </div>
          </div>

          <div className="bg-card rounded-lg p-6 shadow-subtle dark:shadow-subtle-dark animated-section flex items-start">
            <div className="mr-4 p-3 rounded-full bg-primary/10 flex-shrink-0">
              <Lightbulb className="w-6 h-6 text-primary" />
            </div>
            <div>
              <h3 className="text-xl font-semibold mb-3">Scientific & Industrial Research</h3>
              <p className="text-muted-foreground">
                Encourage innovation and R&D in industrial advancements, including blockchain, 
                smart contracts, and renewable technologies.
              </p>
            </div>
          </div>

          <div className="bg-card rounded-lg p-6 shadow-subtle dark:shadow-subtle-dark animated-section flex items-start">
            <div className="mr-4 p-3 rounded-full bg-primary/10 flex-shrink-0">
              <Music className="w-6 h-6 text-primary" />
            </div>
            <div>
              <h3 className="text-xl font-semibold mb-3">Arts, Culture & Sports</h3>
              <p className="text-muted-foreground">
                Promote art, culture, and sports activities to nurture talent 
                and preserve heritage.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Mission;